import {ISeoMetadata} from 'coreStore/data/page/types';

/**
 * Converts raw Contentful SEO fields into ISeoMetadata.
 * Replaces the transformation done by PageVisitor for brands
 * that opt out of the Traverser visitor pipeline.
 */
const buildPageMetadata = (seo: any): ISeoMetadata | null => {
	if (!seo) {
		return null;
	}

	const metadata: ISeoMetadata = {
		title: seo.title,
		description: seo.description,
		keywords: seo.keywords,
		pageMetaTags: [],
	};

	if (seo.pageMetaTagsCollection?.items?.length > 0) {
		metadata.pageMetaTags = seo.pageMetaTagsCollection.items.map((item: any) => ({
			ID: item.id ?? item.ID,
			content: item.content,
			name: item.name,
			property: item.property,
		}));
	}

	return metadata;
};

export default buildPageMetadata;
